import { formatCurrency } from "@/lib/portfolioCalculations";

interface PortfolioDisplayProps {
  portfolioSize: number;
}

const PortfolioDisplay = ({ portfolioSize }: PortfolioDisplayProps) => {
  return (
    <div className="bg-gray-50 rounded-lg p-4">
      <div className="bg-navy/10 p-4 rounded-lg border border-navy/20">
        <p className="text-navy-dark font-semibold">
          Portfolio Size: {formatCurrency(portfolioSize)}
        </p>
      </div>
    </div>
  );
};

export default PortfolioDisplay;